
(function ($) {
    $.fn.mcPwStrength = function (options) {
        var fg;
        var settings = $.extend({
            min: 6,
            backgroundColor: "white",
            lang: "de",
            text: {
                de: ["nutzlos", "schwach", "normal", "gut", "stark"],
                at: ["nutzlos", "schwach", "normal", "gut", "stark"],
                en: ["useless", "weak", "normal", "good", "strong"],
                es: ["inútil", "flojo", "normal", "bien", "fuerte"],
                fr: ["inutil(e)", "faible", "normal", "bien", "fort"],
                it: ["inutile", "debole", "normale", "buono", "forte"],
                nl: ["nutteloos", "zwak", "normaal", "goed", "sterk"],
                pl: ["useless", "weak", "normal", "good", "strong"]
            },
            class: ["bg-danger", "bg-warning", "bg-warning", "bg-success", "bg-success"]

        }, options);

        this.filter("input").each(function () {
            var score = 1;
            var i = $(this);
            var fg = $(this).parents(".form-group");

            // create progress bar
            var pb = $('<div/>').addClass("progress-bar").attr({ role: "progressbar", "aria-valuemin": "0", "aria-valuemax": "100" });
            var p = $('<div/>').addClass("progress hide").append(pb).insertAfter(i);

            // keyup
            i.on("keyup", function () {
                var pw = i.val();

                // check for length
                var score = 0;
                if (pw.length < settings.min) {
                    score = 0;
                } else if (pw.length < settings.min * 1.5) {
                    score = 1;
                } else if (pw.length < settings.min * 2) {
                    score = 2;
                } else if (pw.length < settings.min * 2.5) {
                    score = 3;
                } else {
                    score = 4;
                }

                var countNumber = (pw.match(/\d/g) || []).length;
                var countString = (pw.match(/[a-zA-Z]/g) || []).length;
                var countSpecial = (pw.length - countNumber - countString);

                var charRow = 1;
                var chars = [];
                var prevChar;
                var currentRow = 1;
                for (var j = 0; j < pw.length; j++) {
                    var char = pw[j];
                    if (char == prevChar) {
                        ++currentRow;
                        if (currentRow > charRow) {
                            charRow = currentRow;
                        }
                    } else {
                        currentRow = 1;
                    }
                    chars[char] = (isNaN(chars[char]) ? 1 : chars[char] + 1);
                    prevChar = char;
                }

                var charDiff = 0;
                for (key in chars) {
                    if (chars.hasOwnProperty(key)) charDiff++;
                }

                // check for char/number
                if (score > 0) {
                    // positive
                    if (countSpecial > 0) {
                        ++score;
                    }
                    if (countNumber > 0 && countString > 0) {
                        ++score;
                    }
                    // negative
                    if (charRow > 3) {
                        --score;
                    }
                    if (charRow > 5) {
                        --score;
                    }
                    if (countNumber == pw.length) {
                        --score
                    }
                    // real negative
                    if (charDiff < 4) {
                        score = 0;
                    }

                }

                if (score < 0) {
                    score = 0;
                }
                if (score > 4) {
                    score = 4;
                }


                p.removeClass("hide");
                pb.removeClass().addClass("progress-bar").addClass(settings.class[score]).css("width", (score + 1) * 20 + "%").html(settings.text[settings.lang.toLowerCase()][score]);
            });

        });
        return this;
    };
}(jQuery));


